module.exports = {
    // cloudinary developement
    // cloudinary_cloudName: 'dayeblttk',
    // cloudinary_apiKey: '616728461466718',
    // cloudinary_apiSecret: 'RYMOwH4OAk0e7AEAh12xxMysweM',
    // cloudinary_preset: 'v1596539510',
    // cloudinary_settings: 'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

    // cloudinary production
    cloudinary_cloudName: 'xviewzzzx',
    cloudinary_apiKey: '194857481468858',
    cloudinary_apiSecret: 'LkdKocQmShIEArwY3VGlfMU2VZE',
    cloudinary_preset:'v1540590871',
    cloudinary_settings:'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',
    
    currentDomain: window.location.origin,
}


// WEBPACK FOOTER //
// ./src/configurations.js